<template>
  <div class="content-dashboard">
    <div v-if="mode === 'vue-menu'">
      <h3>{{ $t("carnet_client.title") }}</h3>

      <p>{{ $t("carnet_client.description") }}</p>

      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="d-flex gap-4 justify-content-center align-items-center mt-5">
            <div class="icon-wrapper mb-2">
              <div class="d-flex flex-column justify-content-center icon-wrapper-link" @click="mode = 'vue-animaux'">
                <div class="icon-wrapper-inner">
                  <img :src="animal" />
                </div>

                <h4 class="title text-center">{{ $t("carnet_client.menu.animals_title") }}</h4>
              </div>
            </div>

            <div class="icon-wrapper mb-2">
              <div class="d-flex flex-column justify-content-center icon-wrapper-link" @click="mode = 'vue-rappel'">
                <div class="icon-wrapper-inner">
                  <img :src="rappel" />
                </div>

                <h4 class="title text-center">{{ $t("carnet_client.menu.reminders_title") }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="mode === 'vue-animaux'">
      <div class="d-flex justify-content-between align-items-center flex-column-mobile">
        <div class="d-flex gap-2 align-items-center">
          <span class="back-link cursor-pointer" @click="mode = 'vue-menu'"
            ><i class="ti ti-back-left font-20 orange-color pe-2"></i
          ></span>
          <div>
            <h3>{{ $t("carnet_client.menu.animals_title") }}</h3>

            <p class="mb-0 width-p">{{ $t("carnet_client.animals.description") }}</p>
          </div>
        </div>
        <button @click="mode = 'vue-add-animal'" class="btn btn-orange">
          <img :src="plus" class="width-15" /><span class="ps-1">{{ $t("carnet_client.animals.add_button") }}</span>
        </button>
      </div>

      <div class="box-chart mb-3 w-100 p-4 mt-3">
        <!-- État de chargement -->
        <div v-if="isLoadingAnimals" class="text-center py-4">
          <p>Chargement des animaux...</p>
        </div>

        <!-- Erreur -->
        <div v-else-if="animalsError" class="text-center py-4">
          <p class="text-danger">{{ animalsError }}</p>
          <button @click="loadAnimals" class="btn btn-orange btn-sm">Réessayer</button>
        </div>

        <!-- Aucun animal -->
        <div v-else-if="!hasAnimals" class="text-center py-4">
          <p>Aucun animal enregistré</p>
        </div>

        <!-- Liste des animaux -->
        <div v-else>
          <div v-for="animal in formattedAnimals" :key="animal.id" class="gray-box d-block mb-3">
            <div class="accordion-block-box d-flex gap-3 align-items-center">
              <div
                v-if="typeof getAnimalImage(animal) === 'object' && getAnimalImage(animal).type === 'placeholder'"
                class="animal-placeholder"
                :style="{ backgroundColor: getAnimalImage(animal).color }"
              ></div>
              <div
                v-else-if="typeof getAnimalImage(animal) === 'object' && getAnimalImage(animal).type === 'image_with_background'"
                class="animal-image-with-background"
                :style="{ backgroundColor: getAnimalImage(animal).color }"
              >
                <img :src="getAnimalImage(animal).image" class="animal-image-inside" />
              </div>
              <img v-else :src="getAnimalImage(animal)" />
              <div class="accordion-block-info w-100">
                <div class="accordion-block-info-top d-flex align-items-center gap-3">
                  <span class="border-title">{{ animal.displayName }}</span>
                  <p v-if="animal.formattedDate">
                    <i class="ti ti-calendar pe-2 blue-color"></i><small>{{ animal.formattedDate }}</small>
                  </p>
                </div>
                <div class="accordion-block-info-bottom mt-3">
                  <ul class="d-flex align-items-center gap-2">
                    <li v-if="animal.formattedWeight">
                      <span>{{ $t("carnet_client.animals.list.weight_label") }}</span>
                      <strong>{{ animal.formattedWeight }}</strong>
                    </li>

                    <li v-if="animal.breed">
                      <span>{{ $t("carnet_client.animals.list.breed_label") }}</span>
                      <strong>{{ animal.breed }}</strong>
                    </li>

                    <li v-if="animal.gender">
                      <span>{{ $t("carnet_client.animals.list.sex_label") }}</span>
                      <strong>{{ animal.gender }}</strong>
                    </li>

                    <li v-if="animal.nextVaccinationDate">
                      <span>{{ $t("carnet_client.animals.list.reminder_label") }}</span>
                      <strong>Prochain Vacin : {{ formatDate(animal.nextVaccinationDate) }}</strong>
                    </li>
                  </ul>
                  <div class="accordion-block-right d-flex align-items-center gap-3">
                    <button @click="openEditModal(animal)" class="btn btn-orange btn-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="18.5" viewBox="0 0 18.5 18.5">
                        <g id="edit" transform="translate(-3.25 -2.25)">
                          <path
                            id="Tracé_13934"
                            data-name="Tracé 13934"
                            d="M16.475,5.408l2.117,2.117m-.756-3.982L12.109,9.27a2.118,2.118,0,0,0-.579,1.082L11,13l2.648-.53a2.118,2.118,0,0,0,1.082-.579l5.727-5.727a1.854,1.854,0,0,0-2.621-2.621Z"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_13935"
                            data-name="Tracé 13935"
                            d="M19,15v3a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V7A2,2,0,0,1,6,5H9"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                        </g>
                      </svg>
                    </button>
                    <button @click="showDeleteConfirmation(animal.id, animal.name)" class="btn btn-orange btn-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="19.5" viewBox="0 0 17.5 19.5">
                        <g
                          id="delete-svgrepo-com_2_"
                          data-name="delete-svgrepo-com (2)"
                          transform="translate(0.75 0.75)"
                        >
                          <path
                            id="Tracé_5768"
                            data-name="Tracé 5768"
                            d="M10,11v6"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5769"
                            data-name="Tracé 5769"
                            d="M14,11v6"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5770"
                            data-name="Tracé 5770"
                            d="M4,7H20"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5771"
                            data-name="Tracé 5771"
                            d="M6,7H18V18a3,3,0,0,1-3,3H9a3,3,0,0,1-3-3Z"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5772"
                            data-name="Tracé 5772"
                            d="M9,5a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2V7H9Z"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="mode === 'vue-add-animal'">
      <div class="d-flex gap-2">
        <span class="back-link cursor-pointer" @click="mode = 'vue-animaux'"
          ><i class="ti ti-back-left font-20 orange-color pe-2"></i
        ></span>
        <h3>{{ $t("carnet_client.animals.add_title") }}</h3>
      </div>

      <div class="row mt-5 justify-content-center">
        <div class="col-lg-9">
          <form @submit.prevent="handleAddSubmit">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control"> {{ $t("carnet_client.animals.add_form.labels.animal_type") }} </label>

                  <div class="d-flex gap-2 align-items-center w-100">
                    <select
                      v-model="addForm.animalTypeId"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': addErrors.animalTypeId }"
                    >
                      <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                      <option v-for="type in animalTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                    </select>
                    <img :src="addanimal" class="w-10" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control"> {{ $t("carnet_client.animals.add_form.labels.name") }} </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="addForm.name"
                    :class="{ 'is-invalid': addErrors.name }"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control"> {{ $t("carnet_client.animals.add_form.labels.birth_date") }} </label>
                  <div class="date-picker w-100">
                    <input
                      type="date"
                      class="form-control w-100"
                      v-model="addForm.birthDate"
                      :class="{ 'is-invalid': addErrors.birthDate }"
                    />
                    <span class="calendar-icon"><i class="ti ti-calendar"></i> </span>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control"> {{ $t("carnet_client.animals.add_form.labels.weight") }} </label>
                  <div class="number-input-wrapper w-100">
                    <input
                      type="text"
                      class="form-control"
                      v-model="addForm.weight"
                      @input="validateWeight"
                      :class="{ 'is-invalid': addErrors.weight }"
                      placeholder="0.0"
                    />

                    <div class="arrows">
                      <button type="button" @click="incrementWeight">
                        <i class="ti ti-angle-up"></i>
                      </button>
                      <button type="button" @click="decrementWeight">
                        <i class="ti ti-angle-down"></i>
                      </button>
                    </div>
                    <span class="unit">{{ $t("carnet_client.animals.add_form.unit.weight") }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control"> {{ $t("carnet_client.animals.add_form.labels.breed") }} </label>
                  <select
                    v-model="addForm.breed"
                    class="form-select normal-select"
                    :class="{ 'is-invalid': addErrors.breed }"
                    :disabled="!addForm.animalTypeId"
                  >
                    <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                    <option v-for="race in availableRacesForAdd" :key="race.id" :value="race.id">
                      {{ race.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control"> {{ $t("carnet_client.animals.add_form.labels.sex") }} </label>

                  <select
                    v-model="addForm.gender"
                    class="form-select normal-select"
                    :class="{ 'is-invalid': addErrors.gender }"
                  >
                    <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                    <option value="Mâle">Mâle</option>
                    <option value="Femelle">Femelle</option>
                  </select>
                </div>
              </div>
            </div>

            <div v-if="addError" class="alert alert-danger mt-3">
              {{ addError }}
            </div>

            <div class="row mt-4 justify-content-center">
              <div class="col-lg-4">
                <button type="submit" class="btn btn-orange w-100" :disabled="addLoading">
                  <span v-if="addLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ addLoading ? "Ajout..." : $t("carnet_client.buttons.save") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal de confirmation d'ajout -->
    <div
      class="modal fade"
      :class="{ show: addSuccessModal.show }"
      :style="{ display: addSuccessModal.show ? 'block' : 'none' }"
      tabindex="-1"
      aria-labelledby="addSuccessModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="hideAddSuccessModal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal text-center">
            <div class="mb-4">
              <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
            </div>
            <h3 class="mb-3">Animal ajouté</h3>
            <p class="text-muted mb-4">L'animal a été ajouté avec succès.</p>
            <div class="d-flex justify-content-center">
              <button type="button" class="btn btn-orange" @click="hideAddSuccessModal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Backdrop pour le modal d'ajout -->
    <div v-if="addSuccessModal.show" class="modal-backdrop fade show" @click="hideAddSuccessModal"></div>

    <div v-else-if="mode === 'vue-rappel'">
      <div class="d-flex justify-content-between align-items-center flex-column-mobile">
        <div class="d-flex gap-2 align-items-center w-70">
          <span class="back-link cursor-pointer" @click="mode = 'vue-menu'"
            ><i class="ti ti-back-left font-20 orange-color pe-2"></i
          ></span>
          <div>
            <h3>{{ $t("carnet_client.menu.reminders_title") }}</h3>

            <p
              class="mb-0 width-p"
              v-html="$sanitize.sanitizeI18nContent($t('carnet_client.reminders.description'))"
            ></p>
          </div>
        </div>
        <button @click="mode = 'vue-add-rappel'" class="btn btn-orange">
          <img :src="plus" class="width-15" /><span class="ps-1">{{ $t("carnet_client.reminders.add_button") }}</span>
        </button>
      </div>

      <div class="box-chart mb-3 w-100 p-4 mt-3">
        <div v-if="isLoadingReminders" class="text-center py-4">
          <p>Chargement des rappels...</p>
        </div>

        <div v-else-if="remindersError" class="text-center py-4">
          <p class="text-danger">{{ remindersError }}</p>
          <button @click="loadReminders" class="btn btn-orange btn-sm">Réessayer</button>
        </div>

        <div v-else-if="!hasReminders" class="text-center py-4">
          <p>Aucun rappel enregistré</p>
        </div>

        <div v-else>
          <div v-for="reminder in formattedReminders" :key="reminder.id" class="gray-box d-block mb-3">
            <div class="accordion-block-box d-flex gap-3 align-items-center">
              <div
                v-if="
                  typeof getAnimalImageForReminder(reminder) === 'object' &&
                  getAnimalImageForReminder(reminder).type === 'placeholder'
                "
                class="animal-placeholder"
                :style="{ backgroundColor: getAnimalImageForReminder(reminder).color }"
              ></div>
              <div
                v-else-if="
                  typeof getAnimalImageForReminder(reminder) === 'object' &&
                  getAnimalImageForReminder(reminder).type === 'image_with_background'
                "
                class="animal-image-with-background"
                :style="{ backgroundColor: getAnimalImageForReminder(reminder).color }"
              >
                <img :src="getAnimalImageForReminder(reminder).image" class="animal-image-inside" />
              </div>
              <img v-else :src="getAnimalImageForReminder(reminder)" />
              <div class="accordion-block-info w-100">
                <div class="accordion-block-info-top d-flex align-items-center gap-3">
                  <span class="border-title">{{ reminder.animalDisplayName }}</span>
                </div>
                <div class="accordion-block-info-bottom mt-3">
                  <ul class="d-flex align-items-center gap-2">
                    <li>
                      <span>{{ $t("carnet_client.reminders.list.notify_by_label") }}</span>
                      <strong>{{ reminder.notificationMethods }}</strong>
                    </li>

                    <li>
                      <span>{{ $t("carnet_client.reminders.list.title_label") }} </span>
                      <strong>{{ reminder.title }}</strong>
                    </li>

                    <li>
                      <span>{{ $t("carnet_client.reminders.list.notification_date_label") }}</span>
                      <strong>{{ reminder.formattedDate }}</strong>
                    </li>
                  </ul>
                  <div class="accordion-block-right d-flex align-items-center gap-3">
                    <button @click="openEditReminderModal(reminder)" class="btn btn-orange btn-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="18.5" viewBox="0 0 18.5 18.5">
                        <g id="edit" transform="translate(-3.25 -2.25)">
                          <path
                            id="Tracé_13934"
                            data-name="Tracé 13934"
                            d="M16.475,5.408l2.117,2.117m-.756-3.982L12.109,9.27a2.118,2.118,0,0,0-.579,1.082L11,13l2.648-.53a2.118,2.118,0,0,0,1.082-.579l5.727-5.727a1.854,1.854,0,0,0-2.621-2.621Z"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_13935"
                            data-name="Tracé 13935"
                            d="M19,15v3a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V7A2,2,0,0,1,6,5H9"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                        </g>
                      </svg>
                    </button>
                    <button
                      @click="showDeleteReminderConfirmation(reminder.id, reminder.displayName)"
                      class="btn btn-orange btn-circle"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="19.5" viewBox="0 0 17.5 19.5">
                        <g
                          id="delete-svgrepo-com_2_"
                          data-name="delete-svgrepo-com (2)"
                          transform="translate(0.75 0.75)"
                        >
                          <path
                            id="Tracé_5768"
                            data-name="Tracé 5768"
                            d="M10,11v6"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5769"
                            data-name="Tracé 5769"
                            d="M14,11v6"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5770"
                            data-name="Tracé 5770"
                            d="M4,7H20"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5771"
                            data-name="Tracé 5771"
                            d="M6,7H18V18a3,3,0,0,1-3,3H9a3,3,0,0,1-3-3Z"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                          <path
                            id="Tracé_5772"
                            data-name="Tracé 5772"
                            d="M9,5a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2V7H9Z"
                            transform="translate(-4 -3)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="mode === 'vue-add-rappel'">
      <div class="d-flex gap-2">
        <span class="back-link cursor-pointer" @click="mode = 'vue-rappel'"
          ><i class="ti ti-back-left font-20 orange-color pe-2"></i
        ></span>
        <h3>{{ $t("carnet_client.reminders.add_title") }}</h3>
      </div>

      <div class="row mt-5 justify-content-center">
        <div class="col-lg-9">
          <form @submit.prevent="handleAddReminderSubmit">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.notify_by") }}</label>
                  <MultiSelectDropdown
                    :options="[
                      { value: 'email', label: 'Email' },
                      { value: 'message', label: 'SMS' },
                    ]"
                    v-model="addReminderForm.notifyBy"
                    :is-invalid="!!addReminderErrors.notifyBy"
                    :placeholder="$t('carnet_client.reminders.add_form.placeholders.select_notification')"
                  />
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.animal") }}</label>
                  <select
                    v-model="addReminderForm.animalId"
                    class="form-select normal-select"
                    :class="{ 'is-invalid': addReminderErrors.animalId }"
                  >
                    <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                    <option v-for="animal in reminderAnimals" :key="animal.id" :value="animal.id">
                      {{ animal.name }} ({{ animal.typeName }})
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.title") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="addReminderForm.title"
                    :class="{ 'is-invalid': addReminderErrors.title }"
                    required
                  />
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-input">
                  <label class="label-control">{{
                    $t("carnet_client.reminders.add_form.labels.notification_date")
                  }}</label>
                  <div class="date-picker w-100">
                    <input
                      type="date"
                      class="form-control"
                      v-model="addReminderForm.notificationDate"
                      :class="{ 'is-invalid': addReminderErrors.notificationDate }"
                    />
                    <span class="calendar-icon"><i class="ti ti-calendar"></i></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="form-input">
                  <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.recurrence") }}</label>
                  <select
                    v-model="addReminderForm.recurrence"
                    class="form-select normal-select"
                    :class="{ 'is-invalid': addReminderErrors.recurrence }"
                  >
                    <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                    <option value="none">Aucun</option>
                    <option value="monthly">Tous les mois</option>
                    <option value="quarterly">Tous les trois mois</option>
                    <option value="yearly">Tous les ans</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="form-input">
                  <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.description") }}</label>
                  <textarea
                    class="form-control"
                    rows="7"
                    v-model="addReminderForm.description"
                    :class="{ 'is-invalid': addReminderErrors.description }"
                  ></textarea>
                </div>
              </div>
            </div>

            <div v-if="addReminderError" class="alert alert-danger mt-3">
              {{ addReminderError }}
            </div>

            <div class="row mt-4 justify-content-center">
              <div class="col-lg-4">
                <button type="submit" class="btn btn-orange w-100" :disabled="addReminderLoading">
                  <span v-if="addReminderLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ addReminderLoading ? "Ajout..." : $t("carnet_client.buttons.save") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      :class="{ show: addReminderSuccessModal.show }"
      :style="{ display: addReminderSuccessModal.show ? 'block' : 'none' }"
      tabindex="-1"
      aria-labelledby="addReminderSuccessModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="hideAddReminderSuccessModal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal text-center">
            <div class="mb-4">
              <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
            </div>
            <h3 class="mb-3">{{ $t("carnet_client.reminders.add_success_title") }}</h3>
            <p class="text-muted mb-4">{{ $t("carnet_client.reminders.add_success_message") }}</p>
            <div class="d-flex justify-content-center">
              <button type="button" class="btn btn-orange" @click="hideAddReminderSuccessModal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="addReminderSuccessModal.show"
      class="modal-backdrop fade show"
      @click="hideAddReminderSuccessModal"
    ></div>

    <div
      class="modal fade"
      :class="{ show: deleteConfirmation.show }"
      :style="{ display: deleteConfirmation.show ? 'block' : 'none' }"
      tabindex="-1"
      aria-labelledby="deleteModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="hideDeleteConfirmation" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <div v-if="!deleteSuccess">
              <h3>Confirmer la suppression</h3>
              <div class="mt-4 mb-4">
                <p class="mb-3">Êtes-vous sûr de vouloir supprimer cet animal ?</p>
                <div v-if="deleteConfirmation.animalName" class="gray-box">
                  <div class="adress-item bg-transparent d-flex justify-content-start w-100 align-items-center p-3">
                    <p class="mb-0 width-p">
                      <img :src="getAnimalImage(deleteConfirmation)" class="me-2" style="width: 24px; height: 24px" />
                      <strong class="blue-color font-bold">Animal à supprimer :</strong>
                      {{ deleteConfirmation.animalName }}
                    </p>
                  </div>
                </div>

                <div v-if="deleteError" class="alert alert-danger mt-3">
                  {{ deleteError }}
                </div>
              </div>
              <div class="d-flex justify-content-center gap-3">
                <button type="button" class="btn btn-outline-orange" @click="hideDeleteConfirmation">Annuler</button>
                <button type="button" class="btn btn-orange" @click="confirmDelete" :disabled="deletingAnimal">
                  <span v-if="deletingAnimal" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ deletingAnimal ? "Suppression..." : "Supprimer" }}
                </button>
              </div>
            </div>
            <div v-else class="text-center">
              <div class="mb-4">
                <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
              </div>
              <h3 class="mb-3">Animal supprimé</h3>
              <p class="text-muted mb-4">L'animal a été supprimé avec succès.</p>
              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-orange" @click="hideDeleteConfirmation">Fermer</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="deleteConfirmation.show" class="modal-backdrop fade show" @click="hideDeleteConfirmation"></div>

    <div
      class="modal fade"
      :class="{ show: editModal.show }"
      :style="{ display: editModal.show ? 'block' : 'none' }"
      tabindex="-1"
      aria-labelledby="editModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="hideEditModal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <div v-if="!editSuccess">
              <h3>Modifier l'animal</h3>
              <form @submit.prevent="handleEditSubmit" class="mt-4">
                <div class="d-flex gap-3">
                  <div class="input-form">
                    <label class="label-control">{{ $t("carnet_client.animals.add_form.labels.animal_type") }}</label>
                    <div class="d-flex gap-2 align-items-center">
                      <select
                        v-model="editForm.animalTypeId"
                        class="form-select normal-select"
                        :class="{ 'is-invalid': editErrors.animalTypeId }"
                      >
                        <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                        <option v-for="type in animalTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                      </select>
                      <img :src="addanimal" class="w-10" />
                    </div>
                  </div>
                  <div class="input-form">
                    <label class="label-control">{{ $t("carnet_client.animals.add_form.labels.name") }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="editForm.name"
                      :class="{ 'is-invalid': editErrors.name }"
                      required
                    />
                  </div>
                </div>

                <div class="d-flex gap-3">
                  <div class="input-form">
                    <label class="label-control">{{ $t("carnet_client.animals.add_form.labels.birth_date") }}</label>
                    <div class="date-picker" style="position: relative; width: 100%">
                      <input
                        type="date"
                        class="form-control"
                        v-model="editForm.birthDate"
                        :class="{ 'is-invalid': editErrors.birthDate }"
                        style="width: 100%; padding-right: 40px"
                      />
                      <span
                        class="calendar-icon"
                        style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)"
                        ><i class="ti ti-calendar"></i
                      ></span>
                    </div>
                  </div>
                  <div class="input-form">
                    <label class="label-control">{{ $t("carnet_client.animals.add_form.labels.weight") }}</label>
                    <div class="number-input-wrapper">
                      <input
                        type="text"
                        class="form-control"
                        v-model="editForm.weight"
                        @input="validateEditWeight"
                        :class="{ 'is-invalid': editErrors.weight }"
                        placeholder="0.0"
                      />
                      <div class="arrows">
                        <button type="button" @click="incrementEditWeight">
                          <i class="ti ti-angle-up"></i>
                        </button>
                        <button type="button" @click="decrementEditWeight">
                          <i class="ti ti-angle-down"></i>
                        </button>
                      </div>
                      <span class="unit">{{ $t("carnet_client.animals.add_form.unit.weight") }}</span>
                    </div>
                  </div>
                </div>

                <div class="d-flex gap-3">
                  <div class="input-form">
                    <label class="label-control">{{ $t("carnet_client.animals.add_form.labels.breed") }}</label>
                    <select
                      v-model="editForm.breed"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': editErrors.breed }"
                      :disabled="!editForm.animalTypeId"
                    >
                      <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                      <option v-for="race in availableRacesForEdit" :key="race.id" :value="race.id">
                        {{ race.name }}
                      </option>
                    </select>
                  </div>
                  <div class="input-form">
                    <label class="label-control">{{ $t("carnet_client.animals.add_form.labels.sex") }}</label>
                    <select
                      v-model="editForm.gender"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': editErrors.gender }"
                    >
                      <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                      <option value="Mâle">Mâle</option>
                      <option value="Femelle">Femelle</option>
                    </select>
                  </div>
                </div>
                <div v-if="editError" class="alert alert-danger mt-3">
                  {{ editError }}
                </div>
                <div class="d-flex justify-content-center gap-3 mt-4">
                  <button type="button" class="btn btn-outline-orange" @click="hideEditModal">Annuler</button>
                  <button type="submit" class="btn btn-orange" :disabled="editLoading">
                    <span v-if="editLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ editLoading ? "Modification..." : "Modifier" }}
                  </button>
                </div>
              </form>
            </div>
            <div v-else class="text-center">
              <div class="mb-4">
                <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
              </div>
              <h3 class="mb-3">Animal modifié</h3>
              <p class="text-muted mb-4">L'animal a été modifié avec succès.</p>
              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-orange" @click="hideEditModal">Fermer</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="editModal.show" class="modal-backdrop fade show" @click="hideEditModal"></div>

    <div
      class="modal fade"
      :class="{ show: editReminderModal.show }"
      :style="{ display: editReminderModal.show ? 'block' : 'none' }"
      tabindex="-1"
      aria-labelledby="editReminderModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="hideEditReminderModal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <div v-if="!editReminderSuccess">
              <h3>{{ $t("carnet_client.reminders.edit_title") }}</h3>
              <form @submit.prevent="handleEditReminderSubmit" class="mt-4">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-input">
                      <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.notify_by") }}</label>
                      <MultiSelectDropdown
                        :options="[
                          { value: 'email', label: 'Email' },
                          { value: 'message', label: 'SMS' },
                        ]"
                        v-model="editReminderForm.notifyBy"
                        :is-invalid="!!editReminderErrors.notifyBy"
                        :placeholder="$t('carnet_client.reminders.add_form.placeholders.select_notification')"
                      />
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-input">
                      <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.animal") }}</label>
                      <select
                        v-model="editReminderForm.animalId"
                        class="form-select normal-select"
                        :class="{ 'is-invalid': editReminderErrors.animalId }"
                      >
                        <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                        <option v-for="animal in reminderAnimals" :key="animal.id" :value="animal.id">
                          {{ animal.name }} ({{ animal.typeName }})
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-input">
                      <label class="label-control">{{ $t("carnet_client.reminders.add_form.labels.title") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="editReminderForm.title"
                        :class="{ 'is-invalid': editReminderErrors.title }"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-input">
                      <label class="label-control">{{
                        $t("carnet_client.reminders.add_form.labels.notification_date")
                      }}</label>
                      <div class="date-picker">
                        <input
                          type="date"
                          class="form-control"
                          v-model="editReminderForm.notificationDate"
                          :class="{ 'is-invalid': editReminderErrors.notificationDate }"
                        />
                        <span class="calendar-icon"><i class="ti ti-calendar"></i></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-input">
                      <label class="label-control">{{
                        $t("carnet_client.reminders.add_form.labels.recurrence")
                      }}</label>
                      <select
                        v-model="editReminderForm.recurrence"
                        class="form-select normal-select"
                        :class="{ 'is-invalid': editReminderErrors.recurrence }"
                      >
                        <option value="">{{ $t("carnet_client.animals.add_form.placeholders.select") }}</option>
                        <option value="none">Aucun</option>
                        <option value="monthly">Tous les mois</option>
                        <option value="quarterly">Tous les trois mois</option>
                        <option value="yearly">Tous les ans</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-input">
                      <label class="label-control">{{
                        $t("carnet_client.reminders.add_form.labels.description")
                      }}</label>
                      <textarea
                        class="form-control"
                        rows="7"
                        v-model="editReminderForm.description"
                        :class="{ 'is-invalid': editReminderErrors.description }"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div v-if="editReminderError" class="alert alert-danger mt-3">
                  {{ editReminderError }}
                </div>

                <div class="d-flex justify-content-center gap-3 mt-4">
                  <button type="button" class="btn btn-outline-orange" @click="hideEditReminderModal">Annuler</button>
                  <button type="submit" class="btn btn-orange" :disabled="editReminderLoading">
                    <span v-if="editReminderLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ editReminderLoading ? "Modification..." : $t("carnet_client.buttons.save") }}
                  </button>
                </div>
              </form>
            </div>
            <div v-else class="text-center">
              <div class="mb-4">
                <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
              </div>
              <h3 class="mb-3">{{ $t("carnet_client.reminders.edit_success_title") }}</h3>
              <p class="text-muted mb-4">{{ $t("carnet_client.reminders.edit_success_message") }}</p>
              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-orange" @click="hideEditReminderModal">Fermer</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="editReminderModal.show" class="modal-backdrop fade show" @click="hideEditReminderModal"></div>

    <div
      class="modal fade"
      :class="{ show: deleteReminderConfirmation.show }"
      :style="{ display: deleteReminderConfirmation.show ? 'block' : 'none' }"
      tabindex="-1"
      aria-labelledby="deleteReminderModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="hideDeleteReminderConfirmation" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <div v-if="!deleteReminderSuccess">
              <h3>{{ $t("carnet_client.reminders.delete_title") }}</h3>
              <div class="mt-4 mb-4">
                <p class="mb-3">{{ $t("carnet_client.reminders.delete_confirmation") }}</p>
                <div v-if="deleteReminderConfirmation.reminderName" class="gray-box">
                  <div class="adress-item bg-transparent d-flex justify-content-start w-100 align-items-center p-3">
                    <p class="mb-0 width-p">
                      <img
                        :src="getAnimalImage(deleteReminderConfirmation)"
                        class="me-2"
                        style="width: 24px; height: 24px"
                      />
                      <strong class="blue-color font-bold">{{ $t("carnet_client.reminders.delete_item") }} :</strong>
                      {{ deleteReminderConfirmation.reminderName }}
                    </p>
                  </div>
                </div>

                <div v-if="deleteReminderError" class="alert alert-danger mt-3">
                  {{ deleteReminderError }}
                </div>
              </div>
              <div class="d-flex justify-content-center gap-3">
                <button type="button" class="btn btn-outline-orange" @click="hideDeleteReminderConfirmation">
                  Annuler
                </button>
                <button
                  type="button"
                  class="btn btn-orange"
                  @click="confirmDeleteReminder"
                  :disabled="deletingReminder"
                >
                  <span v-if="deletingReminder" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ deletingReminder ? "Suppression..." : "Supprimer" }}
                </button>
              </div>
            </div>
            <div v-else class="text-center">
              <div class="mb-4">
                <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
              </div>
              <h3 class="mb-3">{{ $t("carnet_client.reminders.delete_success_title") }}</h3>
              <p class="text-muted mb-4">{{ $t("carnet_client.reminders.delete_success_message") }}</p>
              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-orange" @click="hideDeleteReminderConfirmation">Fermer</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="deleteReminderConfirmation.show"
      class="modal-backdrop fade show"
      @click="hideDeleteReminderConfirmation"
    ></div>
  </div>
</template>

<script>
  import animal from "@/assets/images/animal.svg";
  import animals from "@/assets/images/animal.png";
  import rappel from "@/assets/images/rappel.svg";
  import addanimal from "@/assets/images/animal-add.svg";
  import plus from "@/assets/images/plus.svg";
  import chien1 from "@/assets/images/chien1.jpg";
  import chat1 from "@/assets/images/chat1.png";
  import cheval from "@/assets/images/cheval-orange.png";
  import bovin from "@/assets/images/Bovin.png";
  import { useAnimalsStore } from "@/stores/esupplyvet/animalsStore";
  import { useRemindersStore } from "@/stores/esupplyvet/remindersStore";
  import MultiSelectDropdown from "@/components/common/MultiSelectDropdown.vue";

  export default {
    name: "CarnetClientView",
    components: {
      MultiSelectDropdown,
    },
    data() {
      return {
        plus,
        animal,
        addanimal,
        animals,
        rappel,
        chien1,
        chat1,
        cheval,
        bovin,
        mode: "vue-menu",
        animalsStore: useAnimalsStore(),
        remindersStore: useRemindersStore(),
        reminderAnimals: [],
        deleteConfirmation: {
          show: false,
          animalId: null,
          animalName: "",
        },
        deleteReminderConfirmation: {
          show: false,
          reminderId: null,
          reminderName: "",
        },
        deleteError: null,
        deleteReminderError: null,
        deleteSuccess: false,
        deleteReminderSuccess: false,
        deletingAnimal: false,
        deletingReminder: false,
        editModal: {
          show: false,
          animalId: null,
        },
        editReminderModal: {
          show: false,
          reminderId: null,
        },
        editForm: {
          animalTypeId: "",
          name: "",
          birthDate: "",
          weight: 0,
          breed: "",
          gender: "",
        },
        editReminderForm: {
          notifyBy: [],
          animalId: "",
          title: "",
          notificationDate: "",
          recurrence: "",
          description: "",
        },
        editErrors: {},
        editReminderErrors: {},
        editError: null,
        editReminderError: null,
        editSuccess: false,
        editReminderSuccess: false,
        editLoading: false,
        editReminderLoading: false,
        addForm: {
          animalTypeId: "",
          name: "",
          birthDate: "",
          weight: 0,
          breed: "",
          gender: "",
        },
        addReminderForm: {
          notifyBy: [],
          animalId: "",
          title: "",
          notificationDate: "",
          recurrence: "",
          description: "",
        },
        addErrors: {},
        addReminderErrors: {},
        addError: null,
        addReminderError: null,
        addLoading: false,
        addReminderLoading: false,
        addSuccessModal: {
          show: false,
        },
        addReminderSuccessModal: {
          show: false,
        },
      };
    },
    computed: {
      formattedAnimals() {
        return this.animalsStore.formattedAnimals.map(animal => {
          let formattedDate = "";
          if (animal.birthDate) {
            formattedDate = animal.birthDate.split(" ")[0];
          }
          let breedName = animal.breed;
          if (animal.breed && this.animalsStore.animalRaces.length > 0) {
            const matchingRace = this.animalsStore.animalRaces.find(race => race.id == animal.breed);
            if (matchingRace) {
              breedName = matchingRace.name;
            }
          }
          return {
            ...animal,
            formattedDate: formattedDate ? new Date(formattedDate).toLocaleDateString("fr-FR") : null,
            breed: breedName,
          };
        });
      },
      isLoadingAnimals() {
        return this.animalsStore.loading;
      },
      animalsError() {
        return this.animalsStore.error;
      },
      hasAnimals() {
        return this.animalsStore.hasAnimals;
      },
      animalTypes() {
        return this.animalsStore.animalTypes;
      },
      animalRaces() {
        return this.animalsStore.animalRaces;
      },
      availableRacesForAdd() {
        return this.animalsStore.getRacesByAnimalType(this.addForm.animalTypeId);
      },
      availableRacesForEdit() {
        return this.animalsStore.getRacesByAnimalType(this.editForm.animalTypeId);
      },
      formattedReminders() {
        return this.remindersStore.formattedReminders;
      },
      isLoadingReminders() {
        return this.remindersStore.loading;
      },
      remindersError() {
        return this.remindersStore.error;
      },
      hasReminders() {
        return this.remindersStore.hasReminders;
      },
    },
    watch: {
      mode(newMode) {
        if (newMode === "vue-animaux") {
          this.loadAnimals();
          this.loadAnimalRaces();
        } else if (newMode === "vue-rappel") {
          this.loadReminders();
          this.loadReminderAnimals();
        } else if (newMode === "vue-add-animal") {
          this.loadAnimalRaces();
        }
      },
      "addForm.animalTypeId"(newTypeId, oldTypeId) {
        if (newTypeId !== oldTypeId) {
          this.addForm.breed = "";
        }
      },
      "editForm.animalTypeId"(newTypeId, oldTypeId) {
        if (newTypeId !== oldTypeId) {
          this.editForm.breed = "";
        }
      },
    },
    methods: {
      async loadAnimals() {
        await this.animalsStore.fetchAnimals();
      },
      async loadAnimalRaces() {
        if (this.animalsStore.animalRaces.length === 0) {
          await this.animalsStore.fetchAnimalRaces();
        }
      },
      showDeleteConfirmation(animalId, animalName) {
        this.deleteConfirmation = {
          show: true,
          animalId: animalId,
          animalName: animalName,
        };
      },
      hideDeleteConfirmation() {
        this.deleteConfirmation = {
          show: false,
          animalId: null,
          animalName: "",
        };
        this.deleteSuccess = false;
        this.deleteError = null;
        this.deletingAnimal = false;
      },
      async confirmDelete() {
        this.deletingAnimal = true;
        this.deleteError = null;

        try {
          await this.animalsStore.deleteAnimal(this.deleteConfirmation.animalId);
          this.deleteSuccess = true;
        } catch (error) {
          this.deleteError =
            "Erreur lors de la suppression de l'animal. Veuillez vérifier qu'aucun rappel n'est actif pour cet animal avant de retenter la suppression";
        } finally {
          this.deletingAnimal = false;
        }
      },
      async openEditModal(animal) {
        this.editModal = {
          show: true,
          animalId: animal.id,
        };
        this.editSuccess = false;
        this.editError = null;
        this.editErrors = {};

        await this.loadAnimalRaces();
        try {
          const animalData = animal;
          let formattedDate = "";
          if (animalData.birthDate) {
            formattedDate = animalData.birthDate.split(" ")[0];
          }

          let breedValue = "";
          if (animalData.breed) {
            const matchingRace = this.animalsStore.animalRaces.find(race => race.id == animalData.breed);
            if (matchingRace) {
              breedValue = matchingRace.id;
            } else {
              breedValue = animalData.breed;
            }
          }

          this.editForm = {
            animalTypeId: animalData.animalTypeId || "",
            name: animalData.name || "",
            birthDate: formattedDate,
            weight: animalData.weight ? parseFloat(animalData.weight) || 0 : 0,
            breed: breedValue,
            gender: animalData.gender || "",
          };
        } catch (error) {
          this.editError = "Erreur lors du chargement des données de l'animal";
        }
      },
      hideEditModal() {
        this.editModal = {
          show: false,
          animalId: null,
        };
        this.editSuccess = false;
        this.editError = null;
        this.editErrors = {};
        this.editLoading = false;
        this.resetEditForm();
      },
      resetEditForm() {
        this.editForm = {
          animalTypeId: "",
          name: "",
          birthDate: "",
          weight: 0,
          breed: "",
          gender: "",
        };
      },
      validateEditForm() {
        this.editErrors = {};

        if (!this.editForm.name.trim()) {
          this.editErrors.name = "Le nom est requis";
        }

        if (!this.editForm.animalTypeId) {
          this.editErrors.animalTypeId = "Le type d'animal est requis";
        }

        return Object.keys(this.editErrors).length === 0;
      },
      async handleEditSubmit() {
        this.editLoading = true;
        this.editError = null;

        try {
          const formData = {
            ...this.editForm,
            birthDate: this.editForm.birthDate ? this.editForm.birthDate.split(" ")[0] : "",
            weight: this.editForm.weight ? String(this.editForm.weight) : null,
            breed: this.editForm.breed ? String(this.editForm.breed) : "",
          };

          await this.animalsStore.updateAnimal(this.editModal.animalId, formData);
          this.editSuccess = true;
        } catch (error) {
          this.editError = "Erreur lors de la modification de l'animal";
        } finally {
          this.editLoading = false;
        }
      },
      resetAddForm() {
        this.addForm = {
          animalTypeId: "",
          name: "",
          birthDate: "",
          weight: 0,
          breed: "",
          gender: "",
        };
        this.addErrors = {};
        this.addError = null;
      },
      validateAddForm() {
        this.addErrors = {};

        if (!this.addForm.name.trim()) {
          this.addErrors.name = "Le nom est requis";
        }

        if (!this.addForm.animalTypeId) {
          this.addErrors.animalTypeId = "Le type d'animal est requis";
        }

        return Object.keys(this.addErrors).length === 0;
      },
      async handleAddSubmit() {
        if (!this.validateAddForm()) {
          return;
        }

        this.addLoading = true;
        this.addError = null;

        try {
          const formData = {
            ...this.addForm,
            weight: this.addForm.weight ? String(this.addForm.weight) : null,
            breed: this.addForm.breed ? String(this.addForm.breed) : "",
          };

          await this.animalsStore.createAnimal(formData);
          this.resetAddForm();
          this.addSuccessModal.show = true;
          await this.loadAnimals();
        } catch (error) {
          this.addError = "Erreur lors de l'ajout de l'animal";
        } finally {
          this.addLoading = false;
        }
      },
      hideAddSuccessModal() {
        this.addSuccessModal.show = false;
        this.mode = "vue-animaux";
      },
      hideAddReminderSuccessModal() {
        this.addReminderSuccessModal.show = false;
        this.mode = "vue-rappel";
      },
      async loadReminderAnimals() {
        try {
          await this.animalsStore.fetchAnimals();
          this.reminderAnimals = this.animalsStore.animals.map(animal => {
            const animalType = this.animalsStore.animalTypes.find(type => type.id === animal.animalTypeId);
            return {
              ...animal,
              typeName: animalType ? animalType.name : "Type inconnu",
            };
          });
        } catch (error) {
          console.error("Erreur lors du chargement des animaux pour rappels:", error);
        }
      },
      formatDate(dateStr) {
        if (!dateStr) return "";
        const datePart = dateStr.split(" ")[0];
        try {
          return new Date(datePart).toLocaleDateString("fr-FR");
        } catch (e) {
          console.error("Erreur de formatage de date:", e);
          return dateStr;
        }
      },
      validateWeight(event) {
        let value = event.target.value;
        value = value.replace(",", ".");
        if (value && !/^\d*\.?\d*$/.test(value)) {
          this.addErrors.weight = "Valeur invalide";
        } else {
          delete this.addErrors.weight;
          this.addForm.weight = value;
        }
      },
      incrementWeight() {
        let weight = parseFloat(this.addForm.weight) || 0;
        weight = Math.min(weight + 1, 200);
        this.addForm.weight = weight.toString();
      },
      decrementWeight() {
        let weight = parseFloat(this.addForm.weight) || 0;
        weight = Math.max(weight - 1, 0);
        this.addForm.weight = weight.toString();
      },
      validateEditWeight(event) {
        let value = event.target.value;
        value = value.replace(",", ".");
        if (value && !/^\d*\.?\d*$/.test(value)) {
          this.editErrors.weight = "Valeur invalide";
        } else {
          delete this.editErrors.weight;
          this.editForm.weight = value;
        }
      },
      incrementEditWeight() {
        let weight = parseFloat(this.editForm.weight) || 0;
        weight = Math.min(weight + 1, 200);
        this.editForm.weight = weight.toString();
      },
      decrementEditWeight() {
        let weight = parseFloat(this.editForm.weight) || 0;
        weight = Math.max(weight - 1, 0);
        this.editForm.weight = weight.toString();
      },
      async loadReminders() {
        await this.remindersStore.fetchReminders();
      },
      showDeleteReminderConfirmation(reminderId, reminderName) {
        this.deleteReminderConfirmation = {
          show: true,
          reminderId: reminderId,
          reminderName: reminderName,
        };
      },
      hideDeleteReminderConfirmation() {
        this.deleteReminderConfirmation = {
          show: false,
          reminderId: null,
          reminderName: "",
        };
        this.deleteReminderSuccess = false;
        this.deleteReminderError = null;
        this.deletingReminder = false;
      },
      async confirmDeleteReminder() {
        this.deletingReminder = true;
        this.deleteReminderError = null;

        try {
          await this.remindersStore.deleteReminder(this.deleteReminderConfirmation.reminderId);
          this.deleteReminderSuccess = true;
        } catch (error) {
          this.deleteReminderError = "Erreur lors de la suppression du rappel";
        } finally {
          this.deletingReminder = false;
        }
      },
      async openEditReminderModal(reminder) {
        this.editReminderModal = {
          show: true,
          reminderId: reminder.id,
        };
        this.editReminderSuccess = false;
        this.editReminderError = null;
        this.editReminderErrors = {};

        try {
          const reminderData = reminder;
          this.editReminderForm = {
            notifyBy: reminderData.notificationMethods
              ? Array.isArray(reminderData.notificationMethods)
                ? reminderData.notificationMethods
                : [reminderData.notificationMethods]
              : [],
            animalId: reminderData.animalId || "",
            title: reminderData.title || "",
            notificationDate: reminderData.reminderDate ? reminderData.reminderDate.split(" ")[0] : "",
            recurrence: reminderData.recurrence || "",
            description: reminderData.description || "",
          };
        } catch (error) {
          this.editReminderError = "Erreur lors du chargement des données du rappel";
        }
      },
      hideEditReminderModal() {
        this.editReminderModal = {
          show: false,
          reminderId: null,
        };
        this.editReminderSuccess = false;
        this.editReminderError = null;
        this.editReminderErrors = {};
        this.editReminderLoading = false;
        this.resetEditReminderForm();
      },
      resetEditReminderForm() {
        this.editReminderForm = {
          notifyBy: [],
          animalId: "",
          title: "",
          notificationDate: "",
          recurrence: "",
          description: "",
        };
      },
      validateEditReminderForm() {
        this.editReminderErrors = {};

        if (!this.editReminderForm.title.trim()) {
          this.editReminderErrors.title = "Le titre est requis";
        }

        return Object.keys(this.editReminderErrors).length === 0;
      },
      async handleEditReminderSubmit() {
        if (!this.validateEditReminderForm()) {
          return;
        }

        this.editReminderLoading = true;
        this.editReminderError = null;

        try {
          const formData = {
            ...this.editReminderForm,
            notificationMethods:
              this.editReminderForm.notifyBy && this.editReminderForm.notifyBy.length > 0
                ? this.editReminderForm.notifyBy
                : [],
            reminderDate: this.editReminderForm.notificationDate
              ? this.editReminderForm.notificationDate.split(" ")[0]
              : "",
          };

          // Supprimer notifyBy de la requête
          delete formData.notifyBy;
          delete formData.notificationDate;

          await this.remindersStore.updateReminder(this.editReminderModal.reminderId, formData);
          this.editReminderSuccess = true;
          await this.loadReminders();
        } catch (error) {
          this.editReminderError = "Erreur lors de la modification du rappel";
        } finally {
          this.editReminderLoading = false;
        }
      },
      async handleAddReminderSubmit() {
        if (!this.validateAddReminderForm()) {
          return;
        }

        this.addReminderLoading = true;
        this.addReminderError = null;

        try {
          const formData = {
            ...this.addReminderForm,
            notificationMethods:
              this.addReminderForm.notifyBy && this.addReminderForm.notifyBy.length > 0
                ? this.addReminderForm.notifyBy
                : [],
            reminderDate: this.addReminderForm.notificationDate
              ? this.addReminderForm.notificationDate.split(" ")[0]
              : "",
          };

          delete formData.notifyBy;
          delete formData.notificationDate;

          await this.remindersStore.createReminder(formData);
          this.resetAddReminderForm();
          this.addReminderSuccessModal.show = true;
          await this.loadReminders();
        } catch (error) {
          this.addReminderError = "Erreur lors de l'ajout du rappel";
        } finally {
          this.addReminderLoading = false;
        }
      },
      validateAddReminderForm() {
        this.addReminderErrors = {};

        if (!this.addReminderForm.title.trim()) {
          this.addReminderErrors.title = "Le titre est requis";
        }

        return Object.keys(this.addReminderErrors).length === 0;
      },
      resetAddReminderForm() {
        this.addReminderForm = {
          notifyBy: [],
          animalId: "",
          title: "",
          notificationDate: "",
          recurrence: "",
          description: "",
        };
        this.addReminderErrors = {};
        this.addReminderError = null;
      },

      /**
       * Retourne l'image appropriée selon le type d'animal
       * @param {Object} animal - L'objet animal contenant animalTypeId
       * @returns {string} - Le chemin vers l'image appropriée ou un objet spécial pour le cadre
       */
      getAnimalImage(animal) {
        if (!animal || !animal.animalTypeId) {
          return this.animals; // Image par défaut
        }

        const animalTypeId = parseInt(animal.animalTypeId);

        if (animalTypeId === 1) {
          return this.chien1;
        } else if (animalTypeId === 2) {
          return this.chat1;
        } else if (animalTypeId === 3) {
          return {
            type: "image_with_background",
            image: this.cheval,
            color: "#faf2ed",
          };
        } else if (animalTypeId === 4) {
          return {
            type: "image_with_background",
            image: this.bovin,
            color: "#faf2ed",
          };
        } else {
          // Pour les autres types, retourner un objet spécial pour afficher un cadre coloré
          return { type: "placeholder", color: "#faf2ed" };
        }
      },

      /**
       * Retourne l'image appropriée pour un rappel en trouvant l'animal correspondant
       * @param {Object} reminder - L'objet rappel contenant animalId
       * @returns {string} - Le chemin vers l'image appropriée ou un objet spécial pour le cadre
       */
      getAnimalImageForReminder(reminder) {
        if (!reminder || !reminder.animalId) {
          return this.animals; // Image par défaut
        }

        // Trouver l'animal correspondant dans le store des animaux
        const animal = this.animalsStore.animals.find(a => a.id === reminder.animalId);

        if (!animal) {
          return this.animals; // Image par défaut si animal non trouvé
        }

        // Utiliser la logique existante de getAnimalImage
        return this.getAnimalImage(animal);
      },
    },
  };
</script>

<style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-chart {
    max-width: 500px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
  }

  .btn-close {
    background: none;
    border: none;
    font-size: 20px;
    color: #6c757d;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s;
  }

  .btn-close:hover {
    background-color: #f8f9fa;
    color: #495057;
  }

  .modal-body-content p {
    margin-bottom: 12px;
    color: #495057;
  }

  .modal-body-content .text-muted {
    font-size: 14px;
    color: #6c757d !important;
  }

  .btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid transparent;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
  }

  .btn-secondary:hover {
    background-color: #5a6268;
    border-color: #545b62;
  }

  .btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid transparent;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
  }

  .btn-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
  }

  .alert {
    padding: 12px 16px;
    border-radius: 4px;
    border: 1px solid transparent;
  }

  .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .checkbox-label input[type="checkbox"] {
    margin-right: 8px;
  }

  .animal-placeholder {
    width: 135px;
    height: 130px;
    border-radius: 4px;
    display: inline-block;
  }

  .animal-image-with-background {
    width: 135px;
    height: 130px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
  }

  .animal-image-inside {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
</style>
